import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Layout } from "./components/Layout";
import { useDocumentTitle } from './hooks/useDocumentTitle';
import CookieConsent from './components/CookieConsent';

// Pages
import Hero from "./components/Hero";
import Services from "./components/Services";
import Metrics from "./components/Metrics";
import Solutions from "./components/Solutions";
import Approach from "./components/Approach";
import Examples from "./components/Examples";
import AgencyProcessFlow from "./components/ClientPath";
import IntegrationSection from "./components/Integration";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudyPage from './pages/CaseStudyPage';
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";

const MainContent: React.FC = () => {
  useDocumentTitle('home');

  return (
    <Layout>
      <main>
        <Hero />
        <Services />
        <Metrics />
        <Solutions />
        <Approach />
        <Examples />
        <AgencyProcessFlow />
        <IntegrationSection />
        <FAQ />
        <Contact />
      </main>
    </Layout>
  );
};

const TermsPage: React.FC = () => {
  useDocumentTitle('Terms of Service', 'Conditions d\'Utilisation');

  return (
    <Layout>
      <TermsOfService />
    </Layout>
  );
};

const PrivacyPage: React.FC = () => {
  useDocumentTitle('Privacy Policy', 'Politique de Confidentialité');

  return (
    <Layout>
      <PrivacyPolicy />
    </Layout>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <LanguageProvider>
          <Routes>
            {/* English Routes */}
            <Route path="/" element={<MainContent />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* French Routes */}
            <Route path="/fr" element={<MainContent />} />
            <Route path="/fr/case-studies" element={<CaseStudiesPage />} />
            <Route path="/fr/case-studies/:slug" element={<CaseStudyPage />} />
            <Route path="/fr/terms" element={<TermsPage />} />
            <Route path="/fr/privacy" element={<PrivacyPage />} />

            {/* Catch all route - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
        </LanguageProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
